<template>
<div class="chapter">
<div class="inner_page">
<div class="bodyMatter">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<a id="page19"></a>
<div class="partBody">
<div class="chapter" id="dm01">
<h2 class="partNumber"><span class="xrefInternal"><a href="#/contents#pt_01"><span class="bold">PART 1</span></a></span></h2>
<h2 class="partTitle"><span class="xrefInternal"><a href="#/contents#pt_01"><span class="bold">ERA:<br/> Expansion</span></a></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><em class="italic">It was, I saw, the morning of mankind, two thousand years before my own birth.</em></p>
<p class="para"><em class="italic">“It’s difficult now to recapture the mood of those times,” Eve said. “Confidence—arrogance…”</em></p>
<p class="para"><em class="italic">Earth was restored. Great macroengineering projects, supplemented by the nanoengineering of the atmosphere and lithosphere and the transfer off-planet of most power-generating and industrial concerns, had stabilized and preserved the planet’s fragile ecosystem. There was more woodland covering the temperate regions than at any time since the last glaciation, locking in much of the excess carbon dioxide which had plagued previous centuries. And the great decline in species suffered after the industrialization of previous millennia was reversed, thanks to the use of genetic archives and careful reconstruction—from disparate descendants—of lost genotypes.</em></p>
<p class="para"><em class="italic">Earth was the first planet to be terraformed.</em></p>
<p class="para"><em class="italic">Meanwhile the Solar System was opened up.</em></p>
<p class="para"><em class="italic">Based in the orbit of Jupiter, an engineer called Michael Poole industriously took natural microscopic wormholes—flaws in space-time—and expanded them, making transit links big enough to permit spaceships to pass through.</em></p>
<a id="page20"></a>
<p class="para"><em class="italic">Poole Interfaces were towed out of Jovian orbit and set up all over the System. The wormholes which connected the Interfaces enabled the inner System to be traversed in a matter of hours, rather than months. The Jovian system became a hub for interplanetary commerce.</em></p>
<p class="para"><em class="italic">And Port Sol—a Kuiper ice-object on the rim of the System—was to be established as the base for the first great interstellar voyages…</em></p>
</div>
</div></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt01.vue?749588ae